import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithdrawalPaypalComponent } from './withdrawal-paypal.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    WithdrawalPaypalComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class WithdrawalPaypalModule { }
